export default class AnchorScroll{

    constructor(){
        
        this.goToTop = $('.go-to-top')
        this.goToBlock = $('.js__scroll-to')
        this.eventListener()

    }

    eventListener(){

        this.goToTop.on('click', () => {
            this.scrollTopPage()
        })

        this.goToBlock.on('click', (e) => {
            this.scrollToBlock(e)
        })

    }

    // Go To Top
    scrollTopPage(){
        $('html, body').stop().animate({
            scrollTop: 0
        }, 1000);
    }

    // Go To Block
    scrollToBlock(e){
        let $this = $(e.currentTarget)
        let selectedBlock = $this.data('block')
        let windowWidth = $(window).width()
        let topValue = 100
        if(windowWidth > 991 && windowWidth < 1200){
            topValue = 145
        }
        $('html, body').stop().animate({
            scrollTop: ($('#' + selectedBlock).offset().top -topValue
        )}, 1000);
    }

}